import { render, staticRenderFns } from "./OrdersShow.vue?vue&type=template&id=1e5f1644&"
import script from "./OrdersShow.vue?vue&type=script&lang=js&"
export * from "./OrdersShow.vue?vue&type=script&lang=js&"
import style0 from "./OrdersShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports